/**
 * Channels contains definition of all available communication channels.
 * @const channels
 */
/*
    Can be used like: channels.legacy.oddStyle.all
*/
export var channels = {
    legacy: {
        all: "legacy.*",
        oddStyle: {
            all: "legacy.oddStyle.*",
            update: "legacy.oddStyle.update",
            request: "legacy.oddStyle.request"
        },
        timeZone: {
            all: "legacy.timeZone.*",
            update: "legacy.timeZone.update",
            request: "legacy.timeZone.request"
        },
        eventView: {
            all: "legacy.eventView.*",
            event: {
                all: "legacy.eventView.event.*",
                update: "legacy.eventView.event.update"
            }
        }
    },
    eventsFilter: {
        all: "eventsFilter.*",
        sports: "eventsFilter.sports",
        dates: "eventsFilter.dates",
        liveStream: "eventsFilter.liveStream",
        favorites: "eventsFilter.favorites"
    },
    eventsList: {
        count: "eventsList.count"
    },
    favoriteEvents: {
        all: "favoriteEvents.*",
        add: "favoriteEvents.add",
        remove: "favoriteEvents.remove"
    },
    tabSwitcher: {
        all: "legacy.tabSwitcher.*",
        goToNextTab: "legacy.tabSwitcher.goToNextTab",
        showHideTab: "legacy.tabSwitcher.showHideTab"
    },
    aggregatedEvents: {
        incident: {
            all: "aggregatedEvents.incident.*",
            update: "aggregatedEvents.incident.update"
        },
        games: {
            all: "aggregatedEvents.games.*",
            update: "aggregatedEvents.games.update"
        },
        scores: {
            all: "aggregatedEvents.scores.*",
            update: "aggregatedEvents.scores.update"
        },
        currentId: {
            all: "aggregatedEvents.currentId.*",
            update: "aggregatedEvents.currentId.update",
            request: "aggregatedEvents.currentId.request"
        },
        generalInfo: {
            all: "aggregatedEvents.generalInfo.*",
            update: "aggregatedEvents.generalInfo.update"
        }
    }
};
//# sourceMappingURL=channels.js.map